import React, { PureComponent, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Card, CardBody, Row, Col } from "reactstrap";
import MatTableView from "./MatTableView";
import MatTableFiltersSelect from "./MatTableFiltersSelect";
import ColumnConfigurator from "./ColumnConfigurator";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import ListViewIcon from "mdi-react/FormatListBulletedIcon";
import GridViewIcon from "mdi-react/GridIcon";

import MatAppBar from "../../../shared/components/building_filters/UnitsSearchAppBar";
import LinearLoading from "../../../shared/components/LinearLoading";

import { isMobile } from "react-device-detect";
import { Tooltip } from "@material-ui/core";
import moment from "moment";
import { _axiosCall } from "../../../shared/helpers/apicalls";
import {
	_capitalizeText,
	_formatNumber,
	_formatPrice,
	_nameToUrl,
	_shouldShow,
	_getBuildingURL,
	_isEqual,
	_tranformTagsQuery,
	syncURLFilters,
	syncURLSearch,
	setURLFromState,
	setLocalStorage,
	getLocalStorage,
	deleteLocalStorage,
	syncStageFilters,
	syncGenericFilter,
	_objectEqual,
	buildingExportFL,
	GenerateBuildingSlug,
	GenerateBuildingKey,
} from "../../../shared/helpers/utils";

import {
	_buildingSearchFilters,
	_buildingSearchCategoryFilter,
} from "../../../shared/helpers/filters";

import { buildingSearchColumns, defaultVisibleColumns } from "./columnConfig";

const buildingUrl = process.env.API_ROOT + "/query/";

const subFilterKey = "subFilters";
const defaultSubFilter = {};
const defaultCategory = "all";

const getFiltersForCategory = (category) => {
	return _buildingSearchFilters.filter((f) => {
		if (!f.show_for_categories) return true;
		return f.show_for_categories.includes(category) || category === "all";
	});
};

class MatTable extends PureComponent {
	lsPre = "BLDG_SEARCH_";

	_getActiveFilters = () => {
		return getFiltersForCategory(this.state ? this.state.selectedCategory : defaultCategory);
	};

	state = {
		order: syncGenericFilter("order", this.lsPre, "order", "desc"),
		orderBy: syncGenericFilter(
			"order_by",
			this.lsPre,
			"orderBy",
			"total_units"
		),
		selected: new Map([]),
		page: 0,
		rowsPerPage: 40,
		buildingsFetchInProgress: false,
		clearInput: false,
		end: 30,
		reactTableFiltered: [],
		start: 0,
		stats: {},
		subFilters: syncURLFilters(
			this.props,
			getFiltersForCategory(defaultCategory),
			subFilterKey,
			this.lsPre,
			defaultSubFilter
		),
		tableData: false,
		totalCount: 0,
		searchText: syncURLSearch(this.props, "searchText"),
		viewType: syncGenericFilter("viewType", "viewType", this.lsPre, "list"),
		facetData: null,
		selectedCategory: syncGenericFilter(
			"property_category",
			"selectedCategory",
			this.lsPre,
			defaultCategory
		),
		selectedItems: {},
		visibleColumns: this._loadVisibleColumns(),
	};

	q = "";
	fq = [];
	sort = "";

	_loadVisibleColumns() {
		try {
			const stored = getLocalStorage(this.lsPre, "visibleColumns");
			if (stored && Array.isArray(stored) && stored.length > 0) {
				return stored;
			}
		} catch (e) {
			// ignore errors
		}
		return [...defaultVisibleColumns];
	}

	componentDidMount() {
		this._getBuildingSearchResults();
	}

	componentDidUpdate(prevProps, prevState) {
		let searchTagsChange = !_isEqual(
			prevProps.searchTags,
			this.props.searchTags
		);

		let categoryChange = prevState.selectedCategory !== this.state.selectedCategory;

		const activeFilters = this._getActiveFilters();
		let subFilterChanged =
			activeFilters.filter((item) => {
				const key = Array.isArray(item.search_key) ? item.search_key[0] : item.search_key;
				return (
					this.state.subFilters[key] !== prevState.subFilters[key]
				);
			}).length > 0;

		if (
			this.state.searchText !== prevState.searchText ||
			this.state.orderBy !== prevState.orderBy ||
			this.state.order !== prevState.order ||
			this.state.page !== prevState.page ||
			this.state.rowsPerPage !== prevState.rowsPerPage ||
			searchTagsChange ||
			subFilterChanged ||
			categoryChange
		) {
			this._getBuildingSearchResults();
		}
	}

	handleRequestSort = (event, property, setOrder) => {
		const orderBy = property;
		let order = setOrder ? setOrder : "desc";
		const { orderBy: stateOrderBy, order: stateOrder } = this.state;

		if (stateOrderBy === property && stateOrder === "desc" && !setOrder) {
			order = "asc";
		}

		this.setState({ order, orderBy });
	};

	handleSelectAllClick = (event, checked) => {
		if (checked) {
			const { tableData } = this.state;
			const newSelected = new Map();
			tableData.map((n) => newSelected.set(n.id, true));
			this.setState({ selected: newSelected });
			return;
		}
		this.setState({ selected: new Map([]) });
	};

	handleClick = (event, id) => {
		event.stopPropagation();
		const { selected } = this.state;
		const newSelected = new Map(selected);
		const value = newSelected.get(id);
		let isActive = true;
		if (value) {
			isActive = false;
		}
		newSelected.set(id, isActive);
		this.setState({ selected: newSelected });
	};

	handleBuildingClick = (event, building) => {
		event.preventDefault();
		event.stopPropagation();
		const buildingURL = _getBuildingURL(building, "key");
		this.props.history.push(buildingURL);
	};

	handleChangePage = (event, page) => {
		this.setState({ page: page, start: page * this.state.rowsPerPage });
	};

	handleChangeRowsPerPage = (event) => {
		this.setState({ rowsPerPage: event.target.value, page: 0, start: 0 });
	};

	isSelected = (id) => {
		const { selected } = this.state;
		return !!selected.get(id);
	};

	_getBuildingSearchResults = async () => {
		const { searchTags } = this.props;
		const {
			selectedCategory,
			start,
			rowsPerPage,
			orderBy,
			order,
			subFilters,
			visibleColumns,
		} = this.state;

		if (!this.state.buildingsFetchInProgress) {
			this.setState({ buildingsFetchInProgress: true });
		}

		// Build q (main query)
		let q = "*:*";
		if (searchTags && searchTags.filter((tag) => tag.type === "text").length > 0) {
			const textParts = searchTags
				.filter((tag) => tag.type === "text")
				.map((tag) => {
					const text = tag.data.toLowerCase();
					const textCaps = _capitalizeText(text, false);
					return `(name:(*${text}* OR *${textCaps}*) OR display_full_street_address:*${text}* OR neighborhood:*${text}*)`;
				});
			q = textParts.join(" AND ");
		}

		// Build fq (filter queries)
		let fq = ["deleted:false"];

		// property_category filter
		if (selectedCategory && selectedCategory !== "all") {
			fq.push(`property_category:"${selectedCategory}"`);
		}

		// Location tags from search bar
		if (searchTags) {
			searchTags
				.filter((tag) => tag.type === "borough")
				.forEach((tag) => {
					fq.push(`borough:"${tag.data}"`);
				});
			searchTags
				.filter((tag) => tag.type === "neighborhood")
				.forEach((tag) => {
					fq.push(`neighborhood:"${tag.data.hood}"`);
				});
		}

		// Sub-filters
		const activeFilters = this._getActiveFilters();
		if (subFilters && Object.keys(subFilters).length > 0) {
			Object.keys(subFilters).forEach((key) => {
				const val = subFilters[key];
				if (!val || val === "") return;

				const filter = activeFilters.find(
					(f) =>
						f.search_key === key ||
						(Array.isArray(f.search_key) && f.search_key.includes(key))
				);
				if (!filter) return;

				if (filter.format_type === "number" && Array.isArray(filter.search_key)) {
					// Range filter - accumulate min/max
					const minKey = filter.search_key[0];
					const maxKey = filter.search_key[1];
					const minVal = subFilters[minKey] || "*";
					const maxVal = subFilters[maxKey] || "*";
					// Only add once (when processing min key)
					if (key === minKey && (minVal !== "*" || maxVal !== "*")) {
						fq.push(`${filter.filter_key}:[${minVal} TO ${maxVal}]`);
					}
				} else if (filter.solr_fq && filter.values) {
					const selected = filter.values.find((v) => v.filter === val);
					if (selected && selected.search_value) {
						fq.push(selected.search_value);
					}
				}
			});
		}

		// Build fl (field list) from visible columns + base fields
		const baseFields = [
			"key", "name", "display_full_street_address", "alternate_addresses",
			"image", "zip", "borough", "neighborhood", "property_category",
			"building_slugs", "id",
		];
		const columnFields = visibleColumns;
		const fl = [...new Set([...baseFields, ...columnFields])].join(",");

		// Build sort
		const sort = `${orderBy} ${order}`;

		// Facets for category counts
		const facet = {
			by_property_category: {
				type: "terms",
				field: "property_category",
				limit: 25,
				mincount: 1,
			},
		};

		// Persist URL state
		setURLFromState(this.props, this.state);

		this.q = q;
		this.fq = fq;
		this.sort = sort;

		let axiosData = {
			url: buildingUrl + "we3-buildings?cache=15",
			method: "post",
			query: {
				q: q,
				fq: fq,
				sort: sort,
				fl: fl,
				wt: "json",
				rows: rowsPerPage,
				start: start,
				"json.facet": facet,
			},
		};

		_axiosCall(axiosData)
			.then((res) => {
				let docs = res && res.docs ? res.docs : [];
				docs.forEach((doc) => {
					if (!doc["building_slugs"]) {
						doc["building_slugs"] = [GenerateBuildingSlug(doc)];
					}
				});
				this.setState({
					buildingsFetchInProgress: false,
					tableData: docs,
					reactTableFiltered: docs,
					totalCount: res ? res.numFound : 0,
					facetData: res && res.facets ? res.facets : null,
				});
			})
			.catch((error) => {
				console.log("Building search error: " + error);
				this.setState({ buildingsFetchInProgress: false });
			});
	};

	_filterTableByInput = (name, eValue) => {
		this.setState({ searchText: eValue });
	};

	_setSubFilter = (search_key, search_val) => {
		const subF = Object.assign({}, this.state.subFilters, {
			[search_key]: search_val,
		});
		this.setState({
			subFilters: subF,
			start: 0,
			page: 0,
		});
		setLocalStorage(this.lsPre, subFilterKey, JSON.stringify(subF));
	};

	__setSubFilters = (subFilters) => {
		const subF = Object.assign({}, this.state.subFilters, subFilters);
		this.setState({
			subFilters: subF,
			start: 0,
			page: 0,
		});
		setLocalStorage(this.lsPre, subFilterKey, JSON.stringify(subF));
	};

	_setSelectedCategory = (category) => {
		const activeFilters = getFiltersForCategory(category);
		const activeKeys = new Set(
			activeFilters.flatMap((f) =>
				Array.isArray(f.search_key) ? f.search_key : [f.search_key]
			)
		);
		const cleanedSubFilters = {};
		Object.keys(this.state.subFilters).forEach((key) => {
			if (activeKeys.has(key)) {
				cleanedSubFilters[key] = this.state.subFilters[key];
			}
		});

		this.setState({
			selectedCategory: category,
			subFilters: cleanedSubFilters,
			start: 0,
			page: 0,
		});
		setLocalStorage(this.lsPre, "selectedCategory", category);
		setLocalStorage(this.lsPre, subFilterKey, JSON.stringify(cleanedSubFilters));
	};

	_resetSubFilter = () => {
		const subF = Object.assign({}, defaultSubFilter);
		this.setState({
			selectedCategory: defaultCategory,
			subFilters: subF,
			start: 0,
			page: 0,
		});
		deleteLocalStorage(this.lsPre, "selectedCategory");
		deleteLocalStorage(this.lsPre, subFilterKey);
	};

	_resetActive = () => {
		let isDefault =
			this.props.searchTags.length === 0 &&
			_objectEqual(defaultSubFilter, this.state.subFilters) &&
			this.state.selectedCategory === defaultCategory;
		return !isDefault;
	};

	_setVisibleColumns = (columnIds) => {
		this.setState({ visibleColumns: columnIds });
		setLocalStorage(this.lsPre, "visibleColumns", JSON.stringify(columnIds));
	};

	_toggleView = (type) => {
		this.setState({ viewType: type });
		setLocalStorage(this.lsPre, "viewType", type);
	};

	_selectUnit(property) {
		const { selectedItems } = this.state;
		const newSelected = Object.assign({}, selectedItems);
		if (newSelected[property.key]) {
			delete newSelected[property.key];
		} else {
			newSelected[property.key] = property;
		}
		this.setState({ selectedItems: Object.assign({}, newSelected) });
	}

	_clearSelect() {
		this.setState({ selectedItems: {} });
	}

	_handleSelectAllClick() {
		const { selectedItems, reactTableFiltered } = this.state;
		let newSelected = {};
		if (Object.keys(selectedItems).length < reactTableFiltered.length) {
			reactTableFiltered.forEach((item) => {
				newSelected[item.key] = item;
			});
		}
		this.setState({ selectedItems: newSelected });
	}

	render() {
		const {
			order,
			orderBy,
			selected,
			rowsPerPage,
			page,
			tableData,
			reactTableFiltered,
			subFilters,
			totalCount,
			viewType,
			buildingsFetchInProgress,
			selectedCategory,
			selectedItems,
			visibleColumns,
			facetData,
		} = this.state;
		const { user } = this.props;

		const tableCount = totalCount;
		const activeFilters = this._getActiveFilters();

		return (
			<Fragment>
				<Row>
					<Col md={12} lg={12}>
						<Card>
							<CardBody className="p-0">
								<MatTableFiltersSelect
									subFilters={subFilters}
									setSubFilter={this._setSubFilter}
									_filters={activeFilters}
									selectedCategory={selectedCategory}
									setSelectedCategory={this._setSelectedCategory}
									facetData={facetData}
								/>
								<MatAppBar
									handleSearch={this._filterTableByInput}
									numSelected={[...selected].filter((el) => el[1]).length}
									handleDeleteSelected={() => {}}
									onRequestSort={this.handleRequestSort}
									subFilters={subFilters}
									resetSubFilter={this._resetSubFilter}
									setSubFilter={this._setSubFilter}
									buildingStages={[]}
									setBuildingStage={() => {}}
									_filters={activeFilters}
									placeHolder={"Building Name, Address, Neighborhood or Borough"}
									buildingAttributes={[]}
									goToBuilding={true}
									hideBuilding={false}
									resetActive={this._resetActive()}
									q={this.q}
									fq={this.fq}
									fl={buildingExportFL}
									sort={this.sort}
									totalCount={totalCount}
									hideOrganizations
									hidePeople
									addProject={false}
									addBuilding={false}
									allowTextSearch
									setSubFilters={this.__setSubFilters}
								/>
								<div>
									{buildingsFetchInProgress ? (
										<LinearLoading />
									) : (
										<div style={{ height: isMobile ? 0 : 20 }} />
									)}
								</div>
								<div className="material-table__header-info">
									<Row>
										<Col md={6} lg={6}>
											<div
												className={"count_subheader"}
												style={{ marginTop: 10 }}
											>
												<span className="bold-text">
													{tableCount > 0 ? _formatNumber(tableCount) : "--"}
												</span>
												{` `}Buildings
											</div>
										</Col>
										<Col md={6} lg={6} className="text-right">
											<ColumnConfigurator
												visibleColumns={visibleColumns}
												setVisibleColumns={this._setVisibleColumns}
											/>
											<span
												className="small-divider"
												style={{ marginLeft: 10 }}
											>
												|
											</span>
											<ButtonGroup
												size="small"
												aria-label="view toggle"
												style={{ marginLeft: 10 }}
											>
												<Tooltip title="See buildings in a list">
													<Button
														disabled={viewType === "list"}
														onClick={() => this._toggleView("list")}
														startIcon={
															<ListViewIcon
																size={14}
																color={viewType !== "list" ? "#780F9E" : "#A3ADC2"}
															/>
														}
													>
														List
													</Button>
												</Tooltip>
											</ButtonGroup>
										</Col>
									</Row>
								</div>
								<MatTableView
									{...this.state}
									{...this.props}
									handleChangePage={this.handleChangePage}
									handleChangeRowsPerPage={this.handleChangeRowsPerPage}
									isSelected={this.isSelected}
									handleBuildingClick={this.handleBuildingClick}
									handleRequestSort={this.handleRequestSort}
									selectUnit={this._selectUnit.bind(this)}
									onSelectAllClick={this._handleSelectAllClick.bind(this)}
									visibleColumns={visibleColumns}
								/>
							</CardBody>
						</Card>
					</Col>
				</Row>
			</Fragment>
		);
	}
}

export default connect((state) => ({
	user: state.user,
	searchTags: Array.isArray(state.search.searchTags)
		? state.search.searchTags.slice()
		: [],
}))(withRouter(MatTable));
